// FNP-58: form-shape Zod schema (replaces the prior Yup parallel schema).
import {z} from 'zod';

export const RecordSchema = z.object({
    name: z.string().min(1, 'Required'),
    category: z.string().nullable(),
    description: z.string().nullable(),
});
